import React from 'react'
import { View } from 'oio-react'
import PropTypes from 'prop-types'
import { useRouteMatch } from 'react-router-dom'
import { organizationsWithCover } from 'config/constants/themeDefaults/layoutBox'
import HomeCover from 'src/sites/kits/Home/components/Cover'
import { useOrganization } from 'src/core/graphql/hooks'
import { useGlobalState } from 'src/sites/state'
import Nav from '~/components/MainMenu/Nav'
import Logo from '~/components/MainMenu/Logo'
import MainMenuMobile from '~/components/MainMenu/Mobile'
import ActionBlock from '~/components/MainMenu/SidebarActionBlock'

const BoxLayout = ({ children }) => {
   const match = useRouteMatch()
   const { theme } = useGlobalState()
   const { organization } = useOrganization()
   const hasLogo = organization[theme.globalNavLogoFieldName]?.file
   const hasHomeCover = organizationsWithCover.includes(organization.slug)
   const homeCoverIsVisible = match.url === '/' && match.isExact

   const mainMenuWidth = '25vw[d] 21%[e] 20%[f]'
   const contentContainerWidth = `
      100%[a-c]
      calc(100% - 25vw)[d]
      calc(100% - 21%)[e]
      calc(100% - 20%)[f]
   `

   return (
      <>
         <MainMenuMobile />
         <View
            width="100%"
            height={theme.tmpViewportHeight}
            backgroundColor={theme.tmpBackgroundColor}>
            <View
               transition="300ms scale opacity"
               transform={hasHomeCover && homeCoverIsVisible ? 'scale(0.95)' : 'scale(1)'}
               opacity={hasHomeCover && homeCoverIsVisible ? '0.6' : '1'}
               display="block[a-c] flex[d-f]"
               width="100%"
               height={theme.tmpViewportHeight}
               paddingLeft={`
                  ${theme.tmpViewportPaddingD}[d]
                  ${theme.tmpViewportPaddingE}[e]
                  ${theme.tmpViewportPaddingF}[f]
               `}>
               <View
                  height={theme.tmpViewportHeight}
                  borderRight={`1px solid ${theme.tmpColumnBorderColor}`}
                  display="none[a-c] block[d-f]"
                  width={mainMenuWidth}
                  backgroundColor="#fff">
                  <View
                     width="100%"
                     scroll="on"
                     height="calc(100% - 180px)">
                     <View
                        display="flex"
                        alignItems="center"
                        marginTop="10px[d] 30px[e-f]"
                        paddingVertical={!hasLogo && theme.tmpSpacingTop}
                        paddingHorizontal="30px"
                        minHeight={theme.titlebarLgHeight}
                        width="100%"
                        marginBottom="30px">
                        <Logo maxHeight="auto" maxWidth="100%" />
                     </View>
                     <Nav
                        buttonActiveTextColor={theme.tmpMainMenuButtonActiveTextColor}
                        buttonActiveBackgroundColor={theme.tmpMainMenuButtonActiveBackgroundColor}
                        buttonLineColor={theme.tmpMainMenuLineColor}
                        buttonTextColor={theme.tmpMainMenuButtonTextColor}
                        orientation="vertical"
                     />
                  </View>
                  <View
                     display="flex"
                     alignItems="flex-end"
                     width="100%"
                     height="180px"
                     paddingLeft="20px[d] 30px[e-f]">
                     <ActionBlock />
                  </View>
               </View>
               <View
                  scroll="on"
                  height={theme.tmpViewportHeight}
                  width={contentContainerWidth}>
                  {children}
               </View>
            </View>
         </View>
         {hasHomeCover && <HomeCover />}
      </>
   )
}

BoxLayout.propTypes = {
   children: PropTypes.node.isRequired
}

export default BoxLayout
